import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/ynweb_logow.svg'
import _imports_1 from '@/assets/images/charmClose.svg'
import _imports_2 from '@/assets/images/icon_lectureTelemail.svg'
import _imports_3 from '@/assets/images/icon_innerLinkTeacher.svg'
import _imports_4 from '@/assets/images/icon_innerLinkUniv.svg'
import _imports_5 from '@/assets/images/icon_innerLinkRelated.svg'
import _imports_6 from '@/assets/images/icon_lecturePlayerBtn.svg'
import _imports_7 from '@/assets/images/pamph.svg'
import _imports_8 from '@/assets/images/modal_LectureClose.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("noscript", null, "\n<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-ND4GVCB\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>\n", -1)
const _hoisted_2 = { class: "p-lecture__menu" }
const _hoisted_3 = { class: "p-lecture__menu__inner" }
const _hoisted_4 = {
  key: 0,
  class: "c-button-backTo u-pcOnly",
  onclick: "history.back()",
  value: "遷移"
}
const _hoisted_5 = {
  key: 2,
  class: "p-lecture__number u-spOnly"
}
const _hoisted_6 = { class: "p-lecture__menu l-header" }
const _hoisted_7 = { class: "p-lecture__menu__inner" }
const _hoisted_8 = { class: "header_titleUniv" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "header_logoUniv",
  src: _imports_0,
  alt: "夢ナビ",
  loading: "lazy"
}, null, -1)
const _hoisted_10 = { class: "p-lecture-backbutton" }
const _hoisted_11 = {
  key: 2,
  class: "l-main"
}
const _hoisted_12 = {
  key: 0,
  class: "p-lecture__index"
}
const _hoisted_13 = { class: "p-lecture__number u-pcOnly" }
const _hoisted_14 = { class: "p-lecture__gakumon" }
const _hoisted_15 = ["href"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "p-lecture__title" }
const _hoisted_18 = { class: "p-lecture__img" }
const _hoisted_19 = ["src", "alt"]
const _hoisted_20 = {
  key: 0,
  class: "p-lecture__lead"
}
const _hoisted_21 = { class: "p-lecture__leadTitle" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "p-lecture__lead"
}
const _hoisted_24 = { class: "p-lecture__leadTitle" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 2,
  class: "p-lecture__lead"
}
const _hoisted_27 = { class: "p-lecture__leadTitle" }
const _hoisted_28 = {
  key: 3,
  class: "p-lecture__tag"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 4,
  class: "p-lecture__tag"
}
const _hoisted_31 = {
  key: 0,
  class: "p-lecture__SDGs"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createTextVNode("関連する"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("SDGs")
], -1)
const _hoisted_33 = ["src", "alt"]
const _hoisted_34 = {
  key: 0,
  class: "p-lecture__document"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("dt", null, "参考資料", -1)
const _hoisted_36 = ["href"]
const _hoisted_37 = {
  key: 7,
  class: "p-lecture__opinion"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode("※夢ナビ講義は各講師の見解にもとづく講義内容としてご理解ください。")
const _hoisted_39 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_40 = /*#__PURE__*/_createTextVNode("※夢ナビ講義の内容に関するお問い合わせには対応しておりません。")
const _hoisted_41 = [
  _hoisted_38,
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = {
  class: "u-telemailCharm",
  id: "js-scrollCharm"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("img", {
  class: "u-telemailCharmClose",
  id: "js-scrollCharmClose",
  src: _imports_1,
  alt: "閉じる",
  loading: "lazy"
}, null, -1)
const _hoisted_44 = ["href", "onclick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "テレメール",
  loading: "lazy"
}, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("テレメールでこの大学の"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("パンフを取り寄せよう！")
], -1)
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = { class: "nav__sticky u-spOnly" }
const _hoisted_49 = {
  key: 0,
  id: "nav__innerLink"
}
const _hoisted_50 = /*#__PURE__*/_createStaticVNode("<li><a href=\"#link-teacher\"><img src=\"" + _imports_3 + "\" alt=\"先生情報\" style=\"width:50px;height:36px;\" loading=\"lazy\"><span>先生情報</span></a></li><li><a href=\"#link-univ\"><img src=\"" + _imports_4 + "\" alt=\"大学情報\" style=\"width:46px;height:36px;\" loading=\"lazy\"><span>大学情報</span></a></li><li><a href=\"#link-related\"><img src=\"" + _imports_5 + "\" alt=\"関連講義\" style=\"width:44px;height:36px;\" loading=\"lazy\"><span>関連講義</span></a></li>", 3)
const _hoisted_53 = [
  _hoisted_50
]
const _hoisted_54 = {
  key: 1,
  class: "isUniv",
  id: "nav__innerLink"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "#link-teacher" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "先生情報",
      style: {"width":"50px","height":"36px"},
      loading: "lazy"
    }),
    /*#__PURE__*/_createElementVNode("span", null, "先生情報")
  ])
], -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "#link-univ" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "大学情報",
      style: {"width":"46px","height":"36px"},
      loading: "lazy"
    }),
    /*#__PURE__*/_createElementVNode("span", null, "大学情報")
  ])
], -1)
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = {
  class: "p-lecture__secondary",
  id: "link-teacher",
  ref: "linkTeacher"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h3", { class: "p-teacher__title" }, [
  /*#__PURE__*/_createTextVNode("先生情報"),
  /*#__PURE__*/_createElementVNode("span", { class: "u-pcOnly" }, "／大学情報")
], -1)
const _hoisted_60 = { class: "p-lecture__secondary__inner" }
const _hoisted_61 = {
  key: 0,
  class: "p-lecture__profile"
}
const _hoisted_62 = {
  key: 0,
  class: "movie_wrapper"
}
const _hoisted_63 = { class: "p-profile__img" }
const _hoisted_64 = {
  id: "modal-open-kyoju",
  href: "#"
}
const _hoisted_65 = ["src", "data-bg"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("img", {
  class: "-PlayerBtn",
  src: _imports_6,
  alt: "再生ボタン",
  loading: "lazy"
}, null, -1)
const _hoisted_67 = { id: "c-modalBcPlayerKyoju" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "c-modalBcPlayer__overlay" }, null, -1)
const _hoisted_69 = { class: "c-modalBcPlayer" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "c-modalBcPlayer__close" }, null, -1)
const _hoisted_71 = ["data-video-id"]
const _hoisted_72 = {
  key: 0,
  class: "movie_opendate"
}
const _hoisted_73 = {
  key: 1,
  class: "movie_opendate"
}
const _hoisted_74 = {
  key: 1,
  class: "p-profile__img p-profile__nomovie"
}
const _hoisted_75 = ["src", "data-bg"]
const _hoisted_76 = { class: "p-profile__detail" }
const _hoisted_77 = { class: "p-profile__detailTitle" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_80 = { class: "teacherName" }
const _hoisted_81 = { class: "p-profile__supplement" }
const _hoisted_82 = ["onclick", "href"]
const _hoisted_83 = ["onclick", "href"]
const _hoisted_84 = ["onclick", "href"]
const _hoisted_85 = {
  key: 0,
  class: "p-lecture__summary"
}
const _hoisted_86 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-profile__detailTitle" }, "興味が湧いてきたら、この学問がオススメ！")
], -1)
const _hoisted_87 = { class: "p-lecture__recommend" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = ["href"]
const _hoisted_90 = { class: "pamphdiv" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: "パンフ アイコン",
  loading: "lazy"
}, null, -1)
const _hoisted_92 = {
  key: 2,
  class: "p-lecture__summary -LectureSDGs"
}
const _hoisted_93 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-lecture__univTitle" }, "先生がめざすSDGs")
], -1)
const _hoisted_94 = ["src", "alt"]
const _hoisted_95 = {
  key: 3,
  class: "p-lecture__summary -LectureSDGs -LectureSDGsNone"
}
const _hoisted_96 = { class: "p-lecture__univ" }
const _hoisted_97 = { class: "p-lecture__summary" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-lecture__univTitle" }, "メッセージ")
], -1)
const _hoisted_99 = {
  key: 0,
  class: "p-lecture__summary"
}
const _hoisted_100 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-lecture__univTitle" }, "先生への質問")
], -1)
const _hoisted_101 = { class: "p-profile__faq" }
const _hoisted_102 = { class: "modal_LectureWindow" }
const _hoisted_103 = { class: "modal_LectureContent" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("h4", { class: "modal_LectureTitle" }, "先生の学問へのきっかけは？", -1)
const _hoisted_105 = { class: "modal_LectureDetail" }
const _hoisted_106 = { class: "modal_LectureWindow" }
const _hoisted_107 = { class: "modal_LectureContent" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("h4", { class: "modal_LectureTitle" }, "先輩たちはどんな仕事に携わっているの？", -1)
const _hoisted_109 = { class: "modal_LectureDetail" }
const _hoisted_110 = { class: "modal_LectureWindow" }
const _hoisted_111 = { class: "modal_LectureContent" }
const _hoisted_112 = { class: "modal_LectureTitle" }
const _hoisted_113 = { class: "modal_LectureDetail" }
const _hoisted_114 = {
  key: 0,
  class: "p-lecture__detailDocument"
}
const _hoisted_115 = /*#__PURE__*/_createElementVNode("dt", null, "参考資料", -1)
const _hoisted_116 = { key: 0 }
const _hoisted_117 = ["href"]
const _hoisted_118 = { key: 1 }
const _hoisted_119 = ["href"]
const _hoisted_120 = {
  key: 1,
  class: "p-lecture__talk"
}
const _hoisted_121 = /*#__PURE__*/_createElementVNode("h5", { class: "p-lecture__univTitle" }, "3分のプレゼンテーション動画：夢ナビTALK", -1)
const _hoisted_122 = { class: "p-lecture__talk__inner" }
const _hoisted_123 = {
  key: 0,
  class: "p-lecture__talkImg"
}
const _hoisted_124 = ["onclick", "href"]
const _hoisted_125 = ["src", "alt"]
const _hoisted_126 = {
  key: 1,
  class: "p-lecture__talkTitle"
}
const _hoisted_127 = ["onclick", "href"]
const _hoisted_128 = {
  key: 1,
  class: "p-lecture__more",
  id: "link-univ"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("h3", { class: "p-univ__spTitle u-spOnly" }, "大学情報", -1)
const _hoisted_130 = { class: "p-lecture__summary p-lecture__summary__daigakuinfo" }
const _hoisted_131 = { class: "p-lecture__univTitle" }
const _hoisted_132 = { class: "p-lecture__telemail" }
const _hoisted_133 = {
  key: 0,
  class: "p-telemail__img",
  loading: "lazy"
}
const _hoisted_134 = ["href", "onclick"]
const _hoisted_135 = ["src"]
const _hoisted_136 = ["src"]
const _hoisted_137 = { class: "p-telemail__detail" }
const _hoisted_138 = { class: "p-telemail__relatedLink" }
const _hoisted_139 = { key: 0 }
const _hoisted_140 = ["href", "onclick"]
const _hoisted_141 = {
  key: 0,
  class: "multiple_url u-pcOnly"
}
const _hoisted_142 = ["href", "onclick"]
const _hoisted_143 = {
  key: 1,
  class: "multiple_url u-spOnly"
}
const _hoisted_144 = ["href", "onclick"]
const _hoisted_145 = { class: "multiple_url u-pcOnly" }
const _hoisted_146 = ["href", "onclick"]
const _hoisted_147 = { class: "multiple_url u-spOnly" }
const _hoisted_148 = ["href", "onclick"]
const _hoisted_149 = { key: 2 }
const _hoisted_150 = ["href", "onclick"]
const _hoisted_151 = {
  key: 0,
  class: "p-telemail__charm"
}
const _hoisted_152 = ["href", "onclick"]
const _hoisted_153 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "テレメール",
    loading: "lazy"
  }),
  /*#__PURE__*/_createTextVNode("この大学のパンフを取り寄せる")
], -1)
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = {
  key: 0,
  class: "p-related__summary u-spOnly"
}
const _hoisted_156 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-lecture__univTitle" }, "同じ「先生」の講義")
], -1)
const _hoisted_157 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_158 = ["href", "onclick"]
const _hoisted_159 = ["src", "alt", "data-bg"]
const _hoisted_160 = { class: "p-related__title" }
const _hoisted_161 = {
  key: 0,
  class: "p-related__summary u-spOnly"
}
const _hoisted_162 = /*#__PURE__*/_createElementVNode("h4", { class: "p-lecture__univTitle" }, "同じ「大学」の講義", -1)
const _hoisted_163 = { class: "p-related__listLink" }
const _hoisted_164 = ["onclick", "href"]
const _hoisted_165 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_166 = ["href", "onclick"]
const _hoisted_167 = ["src", "alt", "data-bg"]
const _hoisted_168 = { class: "p-related__title" }
const _hoisted_169 = {
  key: 2,
  class: "p-lecture__related",
  id: "link-related"
}
const _hoisted_170 = {
  key: 0,
  class: "p-related__spTitle u-spOnly"
}
const _hoisted_171 = {
  key: 0,
  class: "p-related__spTitle u-spOnly"
}
const _hoisted_172 = {
  key: 0,
  class: "p-related__summary u-pcOnly"
}
const _hoisted_173 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-related__summaryTitle" }, "同じ「先生」の講義")
], -1)
const _hoisted_174 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_175 = ["href", "onclick"]
const _hoisted_176 = ["src", "alt", "data-bg"]
const _hoisted_177 = { class: "p-related__title" }
const _hoisted_178 = {
  key: 0,
  class: "p-related__summary u-pcOnly"
}
const _hoisted_179 = /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "p-related__summaryTitle" }, "同じ「大学」の講義")
], -1)
const _hoisted_180 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_181 = ["href", "onclick"]
const _hoisted_182 = ["src", "alt", "data-bg"]
const _hoisted_183 = { class: "p-related__title" }
const _hoisted_184 = {
  key: 1,
  class: "p-related__listLink"
}
const _hoisted_185 = ["onclick", "href"]
const _hoisted_186 = { class: "p-related__summary" }
const _hoisted_187 = { class: "p-related__summaryTitle" }
const _hoisted_188 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_189 = ["href", "onclick"]
const _hoisted_190 = ["src", "alt", "data-bg"]
const _hoisted_191 = { class: "p-related__title" }
const _hoisted_192 = { class: "p-related__listLink" }
const _hoisted_193 = ["onclick", "href"]
const _hoisted_194 = { class: "p-related__summary" }
const _hoisted_195 = { class: "p-related__summaryTitle" }
const _hoisted_196 = {
  key: 0,
  class: "p-related__list"
}
const _hoisted_197 = ["href", "onclick"]
const _hoisted_198 = ["src", "alt", "data-bg"]
const _hoisted_199 = { class: "p-related__title" }
const _hoisted_200 = { class: "p-related__listLink" }
const _hoisted_201 = ["onclick", "href"]
const _hoisted_202 = {
  key: 3,
  class: "p-lecture-error100"
}
const _hoisted_203 = /*#__PURE__*/_createTextVNode("ご指定の講義は公開期間が終了しました。")
const _hoisted_204 = { class: "p-lecture-errorlink" }
const _hoisted_205 = ["href"]
const _hoisted_206 = {
  key: 4,
  class: "p-lecture-error200"
}
const _hoisted_207 = /*#__PURE__*/_createTextVNode("ご指定の講義は見つかりませんでした。以下の原因が考えられます。")
const _hoisted_208 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_209 = /*#__PURE__*/_createTextVNode("・メールからの参照等でURLが途切れている。")
const _hoisted_210 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_211 = /*#__PURE__*/_createTextVNode(" ・システムに問題が発生している。")
const _hoisted_212 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_214 = /*#__PURE__*/_createTextVNode(" URLに問題が無い場合は時間をおいて再度アクセスしてください。")
const _hoisted_215 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_216 = { class: "p-lecture-errorlink" }
const _hoisted_217 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppHeader = _resolveComponent("AppHeader")!
  const _component_vue_element_loading = _resolveComponent("vue-element-loading")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (!this.isUniversity && !this.isYL)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_AppHeader),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (!this.isPortal && !this.isMember && !this.isMypage)
                ? (_openBlock(), _createElementBlock("button", _hoisted_4, "戻る"))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "c-button-backTo u-pcOnly",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args))),
                    value: "遷移"
                  }, "閉じる")),
              (this.posts.genko)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "講義No." + _toDisplayString(this.posts.genko.genkono), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(this.posts.daigaku.daigakuname) + "の教員による講義", 1),
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "c-button-backToUniv u-pcOnly",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClose && _ctx.onClickClose(...args))),
              value: "遷移"
            }, "閉じる")
          ])
        ], 64)),
    (this.posts.errorcode == null || this.posts.errorcode == 0)
      ? (_openBlock(), _createElementBlock("main", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass({'wide': _ctx.isYL , 'p-lecture__wrapper': true})
          }, [
            (!this.isUniversity && !this.isYL)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (this.posts.genko)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, "講義No." + _toDisplayString(this.posts.genko.genkono), 1),
                        _createElementVNode("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.genko.gakumonbunyas, (bunya) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (bunya.code != 'gc400')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: _normalizeClass(["c-gakumon", _ctx.classFlag(`${bunya.code}`)]),
                                    href: `./gakumon.html?cd=${bunya.code}`,
                                    target: "_blank"
                                  }, _toDisplayString(bunya.name), 11, _hoisted_15))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: _normalizeClass(["c-gakumon c-gakumonnolink", _ctx.classFlag(`${bunya.code}`)]),
                                    href: `./gakumon.html?cd=${bunya.code}`,
                                    target: "_blank"
                                  }, _toDisplayString(bunya.name), 11, _hoisted_16))
                            ], 64))
                          }), 256))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (this.posts.genko)
              ? (_openBlock(), _createElementBlock("section", {
                  key: 1,
                  class: _normalizeClass({'wide': _ctx.isYL , 'p-lecture__primary': true})
                }, [
                  _createElementVNode("h2", _hoisted_17, _toDisplayString(this.posts.genko.title), 1),
                  _createElementVNode("figure", _hoisted_18, [
                    (this.posts.genko)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "-LectureImg lazyload",
                          src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                          alt: this.posts.genko.title,
                          style: _normalizeStyle(`background-image: url(${this.posts.genko.imageurl})`),
                          loading: "lazy"
                        }, null, 12, _hoisted_19))
                      : _createCommentVNode("", true)
                  ]),
                  (this.posts.genko.komidashi1)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_20, [
                        _createElementVNode("dt", null, [
                          _createElementVNode("h3", _hoisted_21, _toDisplayString(this.posts.genko.komidashi1), 1)
                        ]),
                        (this.posts.genko)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_22, _toDisplayString(_ctx.autoNewLine(this.posts.genko.naiyo1)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (this.posts.genko.komidashi2)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_23, [
                        _createElementVNode("dt", null, [
                          _createElementVNode("h3", _hoisted_24, _toDisplayString(this.posts.genko.komidashi2), 1)
                        ]),
                        (this.posts.genko)
                          ? (_openBlock(), _createElementBlock("dd", _hoisted_25, _toDisplayString(_ctx.autoNewLine(this.posts.genko.naiyo2)), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (this.posts.genko.komidashi3)
                    ? (_openBlock(), _createElementBlock("dl", _hoisted_26, [
                        _createElementVNode("dt", null, [
                          _createElementVNode("h3", _hoisted_27, _toDisplayString(this.posts.genko.komidashi3), 1)
                        ]),
                        _createElementVNode("dd", null, _toDisplayString(_ctx.autoNewLine(this.posts.genko.naiyo3)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!this.isUniversity && !this.isYL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.genko.words, (word) => {
                          return (_openBlock(), _createElementBlock("a", {
                            href: `./result.html?Kw=${_ctx.abc123ToHAN(word)}&SerKbn=j&Mt=1`
                          }, "＃" + _toDisplayString(_ctx.abc123ToHAN(word)), 9, _hoisted_29))
                        }), 256))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.genko.words, (word) => {
                          return (_openBlock(), _createElementBlock("span", null, "＃" + _toDisplayString(_ctx.abc123ToHAN(word)), 1))
                        }), 256))
                      ])),
                  (this.posts.genko.sdgs != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        (this.posts.genko.sdgs.length > 0)
                          ? (_openBlock(), _createElementBlock("dl", _hoisted_31, [
                              _hoisted_32,
                              _createElementVNode("dd", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.genko.sdgs, (sdg) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    src: `./images/sdgs_icon/sdgs_${sdg}_on.svg`,
                                    alt: `SDGs ${sdg}`,
                                    loading: "lazy"
                                  }, null, 8, _hoisted_33))
                                }), 256))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (this.posts.genko.siryos != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        (this.posts.genko.siryos.length > 0)
                          ? (_openBlock(), _createElementBlock("dl", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("dd", null, [
                                _createElementVNode("ul", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.genko.siryos, (siryo) => {
                                    return (_openBlock(), _createElementBlock("li", null, [
                                      _createElementVNode("a", {
                                        href: siryo.link,
                                        target: "_blank"
                                      }, _toDisplayString(siryo.name), 9, _hoisted_36)
                                    ]))
                                  }), 256))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!this.isUniversity && !this.isYL)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, _hoisted_41))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("a", {
                      href: this.posts.daigaku.telemailurl,
                      onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'srsk_button'});`,
                      target: "_blank"
                    }, _hoisted_47, 8, _hoisted_44)
                  ]),
                  _createElementVNode("nav", _hoisted_48, [
                    (!this.isUniversity && !this.isYL)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_49, _hoisted_53))
                      : (_openBlock(), _createElementBlock("ul", _hoisted_54, _hoisted_57))
                  ]),
                  _createElementVNode("section", _hoisted_58, [
                    _hoisted_59,
                    _createElementVNode("div", _hoisted_60, [
                      (this.posts.kyoju)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            (this.posts.kyoju.msgbcid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("figure", _hoisted_63, [
                                    _createElementVNode("a", _hoisted_64, [
                                      (this.posts.kyoju.imageurl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "-PlayerImg lazyload",
                                            src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                            alt: "先生のお写真",
                                            "data-bg": `${this.posts.kyoju.imageurl}`,
                                            loading: "lazy"
                                          }, null, 8, _hoisted_65))
                                        : _createCommentVNode("", true),
                                      _hoisted_66
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _hoisted_68,
                                      _createElementVNode("div", _hoisted_69, [
                                        _hoisted_70,
                                        _createElementVNode("video-js", {
                                          class: "vjs-fluid",
                                          id: "kyoju-player",
                                          "data-account": "5974301585001",
                                          "data-player": "R1t9Dt6OZ",
                                          "data-embed": "default",
                                          controls: "",
                                          "data-video-id": this.posts.kyoju.msgbcid
                                        }, null, 8, _hoisted_71)
                                      ])
                                    ])
                                  ]),
                                  (this.posts.kyoju.messagemovieopendate)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_72, "動画公開 " + _toDisplayString(this.posts.kyoju.messagemovieopendate), 1))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(" ")))
                                ]))
                              : (_openBlock(), _createElementBlock("figure", _hoisted_74, [
                                  (this.posts.kyoju.imageurl)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "-PlayerImg lazyload",
                                        src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                        alt: "先生のお写真",
                                        "data-bg": `${this.posts.kyoju.imageurl}`,
                                        loading: "lazy"
                                      }, null, 8, _hoisted_75))
                                    : _createCommentVNode("", true)
                                ])),
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("h4", _hoisted_77, [
                                _createTextVNode(_toDisplayString(this.posts.kyoju.daigakuname) + " ", 1),
                                _hoisted_78,
                                _createTextVNode(_toDisplayString(this.posts.kyoju.gakubu) + " " + _toDisplayString(this.posts.kyoju.gakka) + " " + _toDisplayString(this.posts.kyoju.gakui), 1),
                                _hoisted_79,
                                _createElementVNode("p", _hoisted_80, _toDisplayString(this.posts.kyoju.name) + " 先生", 1)
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                (this.posts.kyoju.other)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "-SupplementOther",
                                      onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'other_kougi'});`,
                                      href: this.posts.kyoju.other,
                                      target: "_blank"
                                    }, "他の夢ナビ講義", 8, _hoisted_82))
                                  : _createCommentVNode("", true),
                                (this.posts.kyoju.book)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      class: "-SupplementBook",
                                      onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'books'});`,
                                      href: this.posts.kyoju.book,
                                      target: "_blank"
                                    }, "著書", 8, _hoisted_83))
                                  : _createCommentVNode("", true),
                                (this.posts.kyoju.url)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 2,
                                      class: "-SupplementLabo",
                                      onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'labo'});`,
                                      href: this.posts.kyoju.url,
                                      target: "_blank"
                                    }, "研究室", 8, _hoisted_84))
                                  : _createCommentVNode("", true)
                              ]),
                              (this.posts.kyoju.pr)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_85, [
                                    _hoisted_86,
                                    _createElementVNode("dd", _hoisted_87, _toDisplayString(this.posts.kyoju.pr), 1),
                                    (this.posts.kyoju.pamphlinkurl)
                                      ? (_openBlock(), _createElementBlock("dd", _hoisted_88, [
                                          _createElementVNode("a", {
                                            class: "pamphlink",
                                            href: this.posts.kyoju.pamphlinkurl,
                                            target: "_blank"
                                          }, [
                                            _createElementVNode("div", _hoisted_90, [
                                              _hoisted_91,
                                              _createElementVNode("span", null, _toDisplayString(this.posts.kyoju.pamphlinkurlcaption), 1)
                                            ])
                                          ], 8, _hoisted_89)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (this.posts.kyoju.sdgs)
                              ? (_openBlock(), _createElementBlock("dl", _hoisted_92, [
                                  _hoisted_93,
                                  _createElementVNode("dd", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.kyoju.sdgs, (sdg) => {
                                      return (_openBlock(), _createElementBlock("img", {
                                        src: `./images/sdgs_icon/sdgs_${sdg}_on.svg`,
                                        alt: `SDGs ${sdg}`,
                                        loading: "lazy"
                                      }, null, 8, _hoisted_94))
                                    }), 256))
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("dl", _hoisted_95))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("dl", _hoisted_97, [
                          _hoisted_98,
                          _createElementVNode("dd", null, _toDisplayString(_ctx.autoNewLine(this.posts.kyoju.message)), 1)
                        ]),
                        (this.posts.kyoju.kikkake || this.posts.kyoju.job || this.posts.kyoju.why)
                          ? (_openBlock(), _createElementBlock("dl", _hoisted_99, [
                              _hoisted_100,
                              _createElementVNode("dd", null, [
                                _createElementVNode("div", _hoisted_101, [
                                  (this.posts.kyoju.kikkake)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "modal_LectureOpen",
                                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq1Toggle && _ctx.onClickModalFaq1Toggle(...args)))
                                      }, "先生の学問へのきっかけは？"))
                                    : _createCommentVNode("", true),
                                  (this.posts.kyoju.job)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 1,
                                        class: "modal_LectureOpen",
                                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq2Toggle && _ctx.onClickModalFaq2Toggle(...args)))
                                      }, "先輩たちはどんな仕事に携わっているの？"))
                                    : _createCommentVNode("", true),
                                  (this.posts.kyoju.why)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 2,
                                        class: "modal_LectureOpen",
                                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq3Toggle && _ctx.onClickModalFaq3Toggle(...args)))
                                      }, _toDisplayString(this.whytitle), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["modal_LectureWrapper", { 'is_open': _ctx.isModalFaq1Open }]),
                          "data-modal": "modal-faq1"
                        }, [
                          _createElementVNode("div", {
                            class: "modal_LectureMask",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq1Toggle && _ctx.onClickModalFaq1Toggle(...args)))
                          }),
                          _createElementVNode("img", {
                            class: "modal_LectureClose",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq1Toggle && _ctx.onClickModalFaq1Toggle(...args))),
                            src: _imports_8,
                            alt: "閉じる",
                            loading: "lazy"
                          }),
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("div", _hoisted_103, [
                              _hoisted_104,
                              _createElementVNode("div", _hoisted_105, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.autoNewLine(this.posts.kyoju.kikkake)), 1)
                              ])
                            ])
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["modal_LectureWrapper", { 'is_open': _ctx.isModalFaq2Open }]),
                          "data-modal": "modal-faq2"
                        }, [
                          _createElementVNode("div", {
                            class: "modal_LectureMask",
                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq2Toggle && _ctx.onClickModalFaq2Toggle(...args)))
                          }),
                          _createElementVNode("img", {
                            class: "modal_LectureClose",
                            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq2Toggle && _ctx.onClickModalFaq2Toggle(...args))),
                            src: _imports_8,
                            alt: "閉じる",
                            loading: "lazy"
                          }),
                          _createElementVNode("div", _hoisted_106, [
                            _createElementVNode("div", _hoisted_107, [
                              _hoisted_108,
                              _createElementVNode("div", _hoisted_109, [
                                _createElementVNode("p", null, _toDisplayString(this.posts.kyoju.job), 1)
                              ])
                            ])
                          ])
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(["modal_LectureWrapper", { 'is_open': _ctx.isModalFaq3Open }]),
                          "data-modal": "modal-faq3"
                        }, [
                          _createElementVNode("div", {
                            class: "modal_LectureMask",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq3Toggle && _ctx.onClickModalFaq3Toggle(...args)))
                          }),
                          _createElementVNode("img", {
                            class: "modal_LectureClose",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onClickModalFaq3Toggle && _ctx.onClickModalFaq3Toggle(...args))),
                            src: _imports_8,
                            alt: "閉じる",
                            loading: "lazy"
                          }),
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("div", _hoisted_111, [
                              _createElementVNode("h4", _hoisted_112, _toDisplayString(this.whytitle), 1),
                              _createElementVNode("div", _hoisted_113, [
                                _createElementVNode("p", null, _toDisplayString(this.whyreason), 1)
                              ]),
                              (this.whyreferdoc1name != null)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_114, [
                                    _hoisted_115,
                                    _createElementVNode("dd", null, [
                                      _createElementVNode("ul", null, [
                                        (this.whyreferdoc1name)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_116, [
                                              _createElementVNode("a", {
                                                href: this.whyreferdoc1url,
                                                target: "_blank"
                                              }, _toDisplayString(this.whyreferdoc1name), 9, _hoisted_117)
                                            ]))
                                          : _createCommentVNode("", true),
                                        (this.whyreferdoc2name)
                                          ? (_openBlock(), _createElementBlock("li", _hoisted_118, [
                                              _createElementVNode("a", {
                                                href: this.whyreferdoc2url,
                                                target: "_blank"
                                              }, _toDisplayString(this.whyreferdoc2name), 9, _hoisted_119)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 2),
                        (this.posts.kyoju.talk)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                              _hoisted_121,
                              _createElementVNode("div", _hoisted_122, [
                                (this.posts.kyoju.talk.image)
                                  ? (_openBlock(), _createElementBlock("figure", _hoisted_123, [
                                      _createElementVNode("a", {
                                        onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'talk'});`,
                                        href: this.posts.kyoju.talk.link,
                                        target: "_blank"
                                      }, [
                                        _createElementVNode("img", {
                                          src: `${this.posts.kyoju.talk.image}`,
                                          alt: this.posts.kyoju.talk.title,
                                          loading: "lazy"
                                        }, null, 8, _hoisted_125)
                                      ], 8, _hoisted_124)
                                    ]))
                                  : _createCommentVNode("", true),
                                (this.posts.kyoju.talk.title)
                                  ? (_openBlock(), _createElementBlock("h6", _hoisted_126, [
                                      _createElementVNode("a", {
                                        onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'talk'});`,
                                        href: this.posts.kyoju.talk.link,
                                        target: "_blank"
                                      }, _toDisplayString(this.posts.kyoju.talk.title), 9, _hoisted_127)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (this.posts.daigaku)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                            _hoisted_129,
                            _createElementVNode("dl", _hoisted_130, [
                              _createElementVNode("dt", null, [
                                _createElementVNode("h4", _hoisted_131, _toDisplayString(this.posts.daigaku.daigakuname) + "に関心を持ったあなたは", 1)
                              ]),
                              _createElementVNode("dd", null, _toDisplayString(_ctx.autoNewLine(this.posts.daigaku.message)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_132, [
                              (this.posts.daigaku.telemailurl)
                                ? (_openBlock(), _createElementBlock("figure", _hoisted_133, [
                                    _createElementVNode("a", {
                                      href: this.posts.daigaku.telemailurl,
                                      onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'srsk_hyoshi'});`,
                                      target: "_blank"
                                    }, [
                                      (this.posts.daigaku.telemailimage != null)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: `${this.posts.daigaku.telemailimage}`,
                                            alt: "資料請求画面へ",
                                            loading: "lazy"
                                          }, null, 8, _hoisted_135))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: `${_ctx.consts.telemail}_pcsite/images/nowpriting.gif`,
                                            alt: "資料請求画面へ",
                                            loading: "lazy"
                                          }, null, 8, _hoisted_136))
                                    ], 8, _hoisted_134)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_137, [
                                _createElementVNode("ul", _hoisted_138, [
                                  (this.posts.daigaku.dedipamphurl)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_139, [
                                        _createElementVNode("a", {
                                          href: this.posts.daigaku.dedipamphurl,
                                          onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'digipamph'});`,
                                          target: "_blank"
                                        }, "デジタルパンフを表示", 8, _hoisted_140)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (!this.isUniversity && !this.isYL)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (this.posts.daigaku.shingakuinfourls != null)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (this.posts.daigaku.shingakuinfourls.length == 1)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (this.posts.daigaku.shingakuinfourls)
                                                      ? (_openBlock(), _createElementBlock("li", _hoisted_141, [
                                                          _createElementVNode("a", {
                                                            href: this.posts.daigaku.shingakuinfourls[0].url,
                                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'tmss'});`,
                                                            target: "_blank"
                                                          }, "学校情報", 8, _hoisted_142)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    (this.posts.daigaku.shingakuinfourls)
                                                      ? (_openBlock(), _createElementBlock("li", _hoisted_143, [
                                                          _createElementVNode("a", {
                                                            href: this.posts.daigaku.shingakuinfourls[0].url,
                                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'srsk_button'});`,
                                                            target: "_blank"
                                                          }, "学校情報", 8, _hoisted_144)
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.daigaku.shingakuinfourls, (url) => {
                                                      return (_openBlock(), _createElementBlock("li", _hoisted_145, [
                                                        _createElementVNode("a", {
                                                          href: url.url,
                                                          onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'tmss'});`,
                                                          target: "_blank"
                                                        }, "学校情報(" + _toDisplayString(url.gakkouname) + ")", 9, _hoisted_146)
                                                      ]))
                                                    }), 256)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.daigaku.shingakuinfourls, (url) => {
                                                      return (_openBlock(), _createElementBlock("li", _hoisted_147, [
                                                        _createElementVNode("a", {
                                                          href: url.url,
                                                          onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'tmss'});`,
                                                          target: "_blank"
                                                        }, "学校情報(" + _toDisplayString(url.gakkouname) + ")", 9, _hoisted_148)
                                                      ]))
                                                    }), 256))
                                                  ], 64))
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (this.posts.daigaku.koshikiurl)
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_149, [
                                        _createElementVNode("a", {
                                          href: this.posts.daigaku.koshikiurl,
                                          onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'daigaku_url'});`,
                                          target: "_blank"
                                        }, "大学公式サイト", 8, _hoisted_150)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            (this.posts.daigaku.telemailurl)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                  _createElementVNode("a", {
                                    href: this.posts.daigaku.telemailurl,
                                    onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'srsk_button'});`,
                                    target: "_blank"
                                  }, _hoisted_154, 8, _hoisted_152)
                                ]))
                              : _createCommentVNode("", true),
                            (!this.isUniversity && !this.isYL)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  (this.posts.kyojugenkoes != null)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (this.posts.kyojugenkoes.length > 0)
                                          ? (_openBlock(), _createElementBlock("dl", _hoisted_155, [
                                              _hoisted_156,
                                              _createElementVNode("dd", null, [
                                                (this.posts.kyojugenkoes)
                                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_157, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.kyojugenkoes, (univ) => {
                                                        return (_openBlock(), _createElementBlock("li", null, [
                                                          _createElementVNode("a", {
                                                            href: `./lecture.html?gnkcd=${univ.genkocode}${this.paramUniv}${this.paramYL}&SerKbn=4`,
                                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${univ.genkocode}'});`
                                                          }, [
                                                            _createElementVNode("figure", null, [
                                                              _createElementVNode("img", {
                                                                class: "lazyload",
                                                                src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                                alt: univ.title,
                                                                "data-bg": `${univ.image}`,
                                                                loading: "lazy"
                                                              }, null, 8, _hoisted_159)
                                                            ]),
                                                            _createElementVNode("h5", _hoisted_160, _toDisplayString(univ.title), 1)
                                                          ], 8, _hoisted_158)
                                                        ]))
                                                      }), 256))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true),
                            (!this.isUniversity && !this.isYL)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (this.posts.daigakugenkoes != null)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (this.posts.daigakugenkoes.length > 0)
                                          ? (_openBlock(), _createElementBlock("dl", _hoisted_161, [
                                              _createElementVNode("dt", null, [
                                                _hoisted_162,
                                                _createElementVNode("div", _hoisted_163, [
                                                  (this.posts.kyoju)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'other_teacher'});`,
                                                        href: `./result.html?Dg=${this.posts.kyoju.daigakuname}&Dgc=${this.posts.detailaccesslog.CLGAKOCD}&SerKbn=6`
                                                      }, "一覧を表示", 8, _hoisted_164))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("dd", null, [
                                                (this.posts.daigakugenkoes)
                                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_165, [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.daigakugenkoes, (univ) => {
                                                        return (_openBlock(), _createElementBlock("li", null, [
                                                          _createElementVNode("a", {
                                                            href: `./lecture.html?gnkcd=${univ.genkocode}${this.paramUniv}${this.paramYL}&SerKbn=6`,
                                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${univ.genkocode}'});`
                                                          }, [
                                                            _createElementVNode("figure", null, [
                                                              _createElementVNode("img", {
                                                                class: "lazyload",
                                                                src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                                alt: univ.title,
                                                                "data-bg": `${univ.image}`,
                                                                loading: "lazy"
                                                              }, null, 8, _hoisted_167)
                                                            ]),
                                                            _createElementVNode("h5", _hoisted_168, _toDisplayString(univ.title), 1)
                                                          ], 8, _hoisted_166)
                                                        ]))
                                                      }), 256))
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 512)
                ], 2))
              : _createCommentVNode("", true),
            (!this.isYL)
              ? (_openBlock(), _createElementBlock("section", _hoisted_169, [
                  (!this.isUniversity)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (this.posts.wordgenkoes != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (this.posts.wordgenkoes.length > 0)
                                ? (_openBlock(), _createElementBlock("h3", _hoisted_170, "関連講義"))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (this.posts.gakumonbunyagenkoes != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (this.posts.gakumonbunyagenkoes.length > 0)
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_171, "関連講義"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!this.isUniversity)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (this.posts.kyojugenkoes != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (this.posts.kyojugenkoes.length > 0)
                                ? (_openBlock(), _createElementBlock("dl", _hoisted_172, [
                                    _hoisted_173,
                                    _createElementVNode("dd", null, [
                                      (this.posts.kyojugenkoes)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_174, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.kyojugenkoes, (univ) => {
                                              return (_openBlock(), _createElementBlock("li", null, [
                                                _createElementVNode("a", {
                                                  href: `./lecture.html?gnkcd=${univ.genkocode}${this.paramUniv}${this.paramYL}&SerKbn=4`,
                                                  onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${univ.genkocode}'});`
                                                }, [
                                                  _createElementVNode("figure", null, [
                                                    _createElementVNode("img", {
                                                      class: "lazyload",
                                                      src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                      alt: univ.title,
                                                      "data-bg": `${univ.image}`,
                                                      loading: "lazy"
                                                    }, null, 8, _hoisted_176)
                                                  ]),
                                                  _createElementVNode("h5", _hoisted_177, _toDisplayString(univ.title), 1)
                                                ], 8, _hoisted_175)
                                              ]))
                                            }), 256))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (this.posts.daigakugenkoes != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (this.posts.daigakugenkoes.length > 0)
                          ? (_openBlock(), _createElementBlock("dl", _hoisted_178, [
                              _hoisted_179,
                              _createElementVNode("dd", null, [
                                (this.posts.daigakugenkoes)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_180, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.daigakugenkoes, (univ) => {
                                        return (_openBlock(), _createElementBlock("li", null, [
                                          _createElementVNode("a", {
                                            href: `./lecture.html?gnkcd=${univ.genkocode}${this.paramUniv}${this.paramYL}&SerKbn=6`,
                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${univ.genkocode}'});`
                                          }, [
                                            _createElementVNode("figure", null, [
                                              _createElementVNode("img", {
                                                class: "lazyload",
                                                src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                alt: univ.title,
                                                "data-bg": `${univ.image}`,
                                                loading: "lazy"
                                              }, null, 8, _hoisted_182)
                                            ]),
                                            _createElementVNode("h5", _hoisted_183, _toDisplayString(univ.title), 1)
                                          ], 8, _hoisted_181)
                                        ]))
                                      }), 256))
                                    ]))
                                  : _createCommentVNode("", true),
                                (!this.isUniversity)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_184, [
                                      (this.posts.daigakugenkoes)
                                        ? (_openBlock(), _createElementBlock("a", {
                                            key: 0,
                                            onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'other_teacher'});`,
                                            href: `./result.html?Dg=${this.posts.kyoju.daigakuname}&Dgc=${this.posts.detailaccesslog.CLGAKOCD}&SerKbn=6`
                                          }, "一覧を表示", 8, _hoisted_185))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (!this.isUniversity)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("dl", _hoisted_186, [
                          (this.posts.wordgenkoes != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (this.posts.wordgenkoes.length > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("dt", null, [
                                        _createElementVNode("h4", _hoisted_187, "関心ワード「" + _toDisplayString(this.posts.sameword) + "」の講義", 1)
                                      ]),
                                      _createElementVNode("dd", null, [
                                        (this.posts.wordgenkoes)
                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_188, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.wordgenkoes, (word) => {
                                                return (_openBlock(), _createElementBlock("li", null, [
                                                  _createElementVNode("a", {
                                                    href: `./lecture.html?gnkcd=${word.genkocode}&SerKbn=Z`,
                                                    onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${word.genkocode}'});`
                                                  }, [
                                                    _createElementVNode("figure", null, [
                                                      _createElementVNode("img", {
                                                        class: "lazyload",
                                                        src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                        alt: word.title,
                                                        "data-bg": `${word.image}`,
                                                        loading: "lazy"
                                                      }, null, 8, _hoisted_190)
                                                    ]),
                                                    _createElementVNode("h5", _hoisted_191, _toDisplayString(word.title), 1)
                                                  ], 8, _hoisted_189)
                                                ]))
                                              }), 256))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_192, [
                                          (this.posts.wordgenkoes)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'other_word'});`,
                                                href: `./result.html?Kw=${this.posts.sameword}&SerKbn=Z&Mt=1`
                                              }, "一覧を表示", 8, _hoisted_193))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("dl", _hoisted_194, [
                          (this.posts.gakumonbunyagenkoes != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (this.posts.gakumonbunyagenkoes.length > 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("dt", null, [
                                        _createElementVNode("h4", _hoisted_195, "学問分野「" + _toDisplayString(this.posts.samebunya) + "」の講義", 1)
                                      ]),
                                      _createElementVNode("dd", null, [
                                        (this.posts.gakumonbunyagenkoes)
                                          ? (_openBlock(), _createElementBlock("ul", _hoisted_196, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.posts.gakumonbunyagenkoes, (gakumonbunya) => {
                                                return (_openBlock(), _createElementBlock("li", null, [
                                                  _createElementVNode("a", {
                                                    href: `./lecture.html?gnkcd=${gakumonbunya.genkocode}&SerKbn=0`,
                                                    onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'osusume_${gakumonbunya.genkocode}'});`
                                                  }, [
                                                    _createElementVNode("figure", null, [
                                                      _createElementVNode("img", {
                                                        class: "lazyload",
                                                        src: `${_ctx.consts.yumenaviinfo}tm_web/common/images/image_holder.png`,
                                                        alt: gakumonbunya.title,
                                                        "data-bg": `${gakumonbunya.image}`,
                                                        loading: "lazy"
                                                      }, null, 8, _hoisted_198)
                                                    ]),
                                                    _createElementVNode("h5", _hoisted_199, _toDisplayString(gakumonbunya.title), 1)
                                                  ], 8, _hoisted_197)
                                                ]))
                                              }), 256))
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_200, [
                                          (this.posts.gakumonbunyagenkoes)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                onclick: `gtag('event','click',{'event_category':'${this.getGENKOCD}','event_label':'other_gakumon'});`,
                                                href: `./result.html?Gm=${this.posts.samebunyacode}&SerKbn=0`
                                              }, "一覧を表示", 8, _hoisted_201))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_vue_element_loading, {
              active: _ctx.loadingshow,
              color: "rgba(110, 185, 43, .4)",
              size: "120",
              duration: "1.0",
              "is-full-screen": ""
            }, null, 8, ["active"])
          ], 2)
        ]))
      : (this.posts.errorcode==100)
        ? (_openBlock(), _createElementBlock("p", _hoisted_202, [
            _hoisted_203,
            _createElementVNode("div", _hoisted_204, [
              _createElementVNode("a", {
                class: "p-lecture-errorlink",
                href: `${_ctx.consts.yumenaviinfo}`
              }, "夢ナビトップページへ", 8, _hoisted_205)
            ])
          ]))
        : (this.posts.errorcode==200)
          ? (_openBlock(), _createElementBlock("p", _hoisted_206, [
              _hoisted_207,
              _hoisted_208,
              _hoisted_209,
              _hoisted_210,
              _hoisted_211,
              _hoisted_212,
              _hoisted_213,
              _hoisted_214,
              _hoisted_215,
              _createElementVNode("div", _hoisted_216, [
                _createElementVNode("a", {
                  class: "p-lecture-errorlink",
                  href: `${_ctx.consts.yumenaviinfo}`
                }, "夢ナビトップページへ", 8, _hoisted_217)
              ])
            ]))
          : _createCommentVNode("", true),
    _createVNode(_component_AppFooter)
  ], 64))
}